export const getActiveError = state => state.error.activeError;
export const getActiveErrorMessage = state => state.error.error || null;